import React, { Component } from "react";
import axios from "axios";
import { MdOutlineDateRange } from "react-icons/md";
// import { GrUpdate } from "react-icons/gr";
import { IoTodayOutline } from "react-icons/io5";
import { WiTime12 } from "react-icons/wi";
import { PiCertificateThin } from "react-icons/pi";
import { FaAppStore } from "react-icons/fa";
import { AiOutlineDatabase } from "react-icons/ai";
import { CiPen } from "react-icons/ci";
import { GiBlackBook } from "react-icons/gi";
import { LuNotebook } from "react-icons/lu";
import { MdOutlineVerifiedUser } from "react-icons/md";
import { GiField } from "react-icons/gi";
import { MdOutlinePhoneInTalk } from "react-icons/md";
import { MdOutlineVerified } from "react-icons/md";
import Naria from "../image/naria.png"
import MapComponent from "./location.map"; // Correct import
// import { PiCurrencyNgn } from "react-icons/pi";
// import { FaRegEdit } from "react-icons/fa";
import NumberDisplay from "./currencyValue";
import { CiLocationOn } from "react-icons/ci";
import DateDisplay from "./user/dateformate";
import ProfileMapComponent from "./location.map.profiile";



class PaymentDescript extends Component {
    state = {
        courses: [],
        user: [],
        profileData: [],
        isEditingprice: false,
        updatedprice: '',
    }
    priceRef = React.createRef();

    componentDidMount() {
        this.fetchCourses(this.props.search);
        const storedUser = localStorage.getItem('user');
        const user = JSON.parse(storedUser);
        this.setState({ user: user })
        this.FetchProfile()
    }

    fetchCourses = async () => {
        const accessToken = localStorage.getItem("accessToken");
        try {
            const course_id = this.props.course_id;
            const courseId = parseInt(course_id, 10);
            const response = await axios.get(`https://api.geoinfoacademy.com/api/courses/${courseId}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            this.setState({ courses: response.data });
            console.log("API Response:", response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
            // Handle errors as needed
        }
    };

    FetchProfile = async () => {
        const accessToken = localStorage.getItem("accessToken");
        try {
            const response = await axios.get("https://api.geoinfoacademy.com/api/student/profile/", {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            //   const profileData = response.data;
            this.setState({
                profileData: response.data
            })
            console.log("checking the profile", response.data)
        } catch (err) {
            console.log("error occurred update the profile", err)
        }
    }




    getIconForOption = (option) => {
        switch (option) {
            case 'Software':
                return <FaAppStore />;
            case 'Data':
                return <AiOutlineDatabase />;
            case 'Biro':

                return <CiPen />;
            case 'Jotter':
                return <LuNotebook />;
            case 'Manual':
                return <GiBlackBook />;
            case '100% Practical':
                return <MdOutlineVerifiedUser />;
            case 'Field Experience':
                return <GiField />;
            case 'Free Consultation':
                return <MdOutlinePhoneInTalk />;
            case 'Exam and Certificate':
                return <PiCertificateThin />;
            case 'Free internship':
                return <MdOutlineVerified />;
            case 'Access job opportunities':
                return <MdOutlineVerified />;
            default:
                return null;
        }
    };

    handlePayForCourse = async (e) => {
        e.preventDefault()
        this.handleUpdate()
        const accessToken = localStorage.getItem("accessToken");
        const { courses } = this.state;

        if (!courses || !courses.id || !courses.price) {
            console.error("Course data is incomplete.");
            return;
        }

        try {
            const response = await axios.post(
                `https://api.geoinfoacademy.com/api/pay/${courses.id}/`,
                {
                    amount_paid: courses.price,
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );

            if (response.data && response.data.payment_url) {
                window.location.href = response.data.payment_url;
            } else {
                console.error("Payment URL not found in response.");
            }
        } catch (error) {
            console.error("Error initiating payment:", error);
        }
    };
    backCourse = (e) => {
        e.preventDefault()
        const { courses } = this.state;
        window.location.href = `/description/${courses.id}`
    }


    handletermsCondition = () => {
        const formcontainer = document.querySelector(".dash_add_course_cover.termscondition")
        formcontainer.style.display = "flex"
        const map = document.querySelector("div.maplocation")
        map.style.display = "none"
    }








    handleInputChange = (event, field) => { // For input fields
        this.setState({ [`updated${field}`]: event.target.value });

    };

    handleProfileInputChange = (event) => {
        const { name, value } = event.target
        this.setState((prevState) => ({
            profileData: {
                ...prevState.profileData,
                [name]: value
            }
        }));
    }
    handleUpdate = async () => {
        const accessToken = localStorage.getItem("accessToken");
        this.setState({ loading: true });
        const { profileData } = this.state
        const finalSource = (profileData.source === "Other")
            ? profileData.OtherSource
            : profileData.source;
        const profileDatas = {
            venue: profileData.venue,
            interested_course: profileData.interested_course,
            source: finalSource,
        };
        const headers = {
            Authorization: `Bearer ${accessToken}`,
        };

        try {
            let response = await axios.patch(`https://api.geoinfoacademy.com/api/student/profile/`, profileDatas, { headers });
            this.setState({
                loading: false
            })
            console.log("API response", response)
        } catch (error) {
            console.error("Submit error:", error);
            this.setState({ loading: false });
        }
    }




    // Toggle editing for other fields
    toggleEditing = (field) => {
        this.setState({
            [`isEditing${field}`]: true,
            [`updated${field}`]: this.state.courses[field],
        });
    };



    submitChanges = (field) => {
        const accessToken = localStorage.getItem("accessToken");
        const course_id = this.props.course_id
        const courseId = parseInt(course_id, 10);
        let updatedvalue = this.state[`updated${field}`];

        if (field === 'duration_from' || field === 'duration_to') {
            if (updatedvalue) { // Check if updatedvalue is not empty
                const dateParts = updatedvalue.split('-');
                if (dateParts.length === 3) {
                    const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
                    updatedvalue = formattedDate; // Update the local variable
                } else {
                    console.error("Invalid date format:", updatedvalue);
                    // Handle invalid date format, perhaps show an error message
                    return; // Stop further execution
                }
            }
        }

        // Send the updatedHeadingText to your API here
        fetch(`https://api.geoinfoacademy.com/api/tutor/courses/${courseId}/`, {
            method: 'PATCH', // Assuming you're updating the existing heading
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ [field]: updatedvalue })
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then(data => {
                // Update headingText with the successfully updated value
                this.fetchCourses();  // <--- This is the crucial change

                this.setState({
                    isEditingprice: false,
                    updatedprice: '',

                });
                console.log('Course updated successfully:', data);
            })
            .catch(error => {
                console.error('There has been a problem with your fetch operation:', error);
            });

        this.setState({ isEditing: false });
    };

    render() {
        const { courses, user, profileData } = this.state
        console.log("checking", this.state.user)
        const coursecontent = courses
        const include = coursecontent && coursecontent.package && coursecontent.package.length ? (
            coursecontent.package.map((packageItem) => (
                <p className="body" key={packageItem}>
                    {this.getIconForOption(packageItem)}
                    <span>{packageItem}</span>
                </p>
            ))
        ) : (<p>Loading...</p>);
        return (
            <div className="dash_descript_payment" >
                <section className="head">
                    <h2>Hi, {user.name}</h2>
                    <h3>You have applied for <span>{courses.title}</span></h3>
                    <p>Training is schedule to start</p>
                    <p>{/*<GrUpdate /> <span>{courses.repeat}</span> */}<MdOutlineDateRange /><DateDisplay data={courses.duration} /> </p>
                    <p><IoTodayOutline /> <span>Thursday & Friday </span> <WiTime12 /><span>12 pm to 2pm</span></p>
                    <p><CiLocationOn /><span>Lagos: Inside Eridan Place, Oluwalogbon House, Testing Ground Bus Stop, Obafemi Awolowo Way, Ikeja, Lagos <br />  Abuja: 6th floor, Nigeria Reinsurance Building, Plot 784A Herbert Macaulay Way, Central Business District, FCT, Abuja</span></p>

                    <section className="left">
                        {this.state.isEditingprice ? (
                            <input
                                type="number"
                                value={this.state.updatedprice}
                                onChange={(e) => this.handleInputChange(e, 'price')}
                                ref={this.priceRef}
                                onBlur={() => this.submitChanges('price')}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        e.preventDefault(); // Prevent default Enter behavior (form submission)
                                        this.submitChanges('price');
                                        this.setState({ isEditingprice: false }); // Close the input after submit
                                    }
                                }}

                            />
                        ) : (
                            <h4><span className="blue">At</span><br />
                                {/* <PiCurrencyNgn /> */}
                                <img src={Naria} alt="naria" /> <NumberDisplay value={courses.price} /> {user.role === "tutor" ? <button className="edit" onClick={() => this.toggleEditing('price')}>Edit Price</button> : null}</h4>
                        )}

                        <p>You are to come along with your laptop and you will be getting </p>
                        {include}
                    </section>
                    <section className="right">
                        <p>Location</p>
                        <div className="maplocation" style={{ height: '300px', width: '100%' }}>
                            {/* <MapComponent /> */}
                            <ProfileMapComponent venue={profileData.venue} />
                        </div>
                    </section>

                    <form onSubmit={this.handlePayForCourse}>

                        <label htmlFor="phone" style={{ margin: "0px" }}>Phone Number</label><br />
                        <input type="number" className="text" name="phone_number" id="phone_number" value={profileData.phone_number} onChange={this.handleProfileInputChange} placeholder="0900000" required /><br /><br />


                        <label htmlFor="venue" style={{ margin: "0px" }}>Select your preferred training venue</label><br />
                        <select name="venue" id='venue' value={profileData.venue} onChange={this.handleProfileInputChange} required>
                            <option value="">Select training venue</option>
                            <option value="Online">Online</option>
                            <option value="Oluwalogbon House, Testing Ground Bus Stop, Obafemi Awolowo Way, Ikeja, Lagos">Oluwalogbon House, Testing Ground Bus Stop, Obafemi Awolowo Way, Ikeja, Lagos</option>
                            <option value="2nd floor Puskin mall, Samuel Mafuyi Street, Opposite AA Rano, Jabi, Abuja">2nd floor Puskin mall, Samuel Mafuyi Street, Opposite AA Rano, Jabi, Abuja</option>
                        </select><br /><br />


                        <label htmlFor="interested_course" style={{ margin: "0px" }}>Area of Specialisation</label><br />
                        <input type="text" className="text" name="interested_course" id="interested_course" value={profileData.interested_course} onChange={this.handleProfileInputChange} placeholder="list interested_course" required /><br /><br />


                        <label htmlFor="source" style={{ margin: "0px" }}>How did you get this information</label><br />
                        <select name="source" id='source' value={profileData.source} onChange={this.handleProfileInputChange} required>
                            <option value="">Select</option>
                            <option value="Friends">Friends</option>
                            <option value="Families">Families</option>
                            <option value="WhatsApp">WhatsApp</option>
                            <option value="T.V/Radio">T.V/Radio</option>
                            <option value="School">School</option>
                            <option value="Social Media">Social Media</option>
                            <option value="Google">Google</option>
                            <option value="Others">Others</option>
                        </select><br /><br />

                        {profileData.source === 'Others' ? (
                            <div><input
                                type="text"
                                className="text"
                                placeholder="Enter other option"
                                name="otherOption"
                                id="otherOption"
                                value={profileData.otherOption}
                                onChange={this.handleProfileInputChange}
                            /><br /><br /></div>) :
                            null}
                        <input type="checkbox" required /><label>Agree to <span onClick={this.handletermsCondition}>terms & condition</span></label><br />
                        <button type="submit">Pay For Course</button>
                        <button onClick={this.backCourse}>Back</button>
                    </form>
                </section>
            </div>
        )
    }
}

export default PaymentDescript